module.exports = __webpack_public_path__ + "static/media/294613.b8af4709.png";